import tableTemplate from './table.html';
import { setSortingFunction } from 'utils/actions/table-sorting/table-sorting.actions';

const SORT_DIRECTION = {
  asc: 'true',
  desc: 'false',
};

const mapStateToThis = ({ ui }) => {
  const { sortingFunction } = ui;
  return {
    sortingFunction,
  };
};

const mapDispatchToThis = {
  setSortingFunction,
};

@Inject('gettextCatalog', '$ngRedux')
export class TableController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit(){
    if (this.defaultSortColumn) {
      this.setSortingFunction({
        [this.defaultSortColumn]: this.defaultSortDirection || SORT_DIRECTION.asc,
      });
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class TableComponent {
  constructor() {
    this.bindings = {
      defaultSortDirection: '@',
      defaultSortColumn: '@?',
      hasData: '=',
      noDataText: '=?',
      loaded: '<',
    };
    this.transclude = true;
    this.template = tableTemplate;
    this.controller = TableController;
  }
}


// WEBPACK FOOTER //
// ./src/modules/utils/grid/table-component.js